export default "__VITE_ASSET__BHjh89EV__"